<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="title">The House of War and Witness</h1>
<p class="author">Mike Carey, Linda Carey, and Louise Carey</p>
<p class="pub"><img alt="logo" src="image/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HouseWarWitness-4.vue?3a606f32